var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{class:{ 'show-padding': !_vm.isLogin }},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('policy-form',{attrs:{"show":_vm.showPolicyCreation},on:{"close":function($event){_vm.showPolicyCreation = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }